const accountTypes = ['operator','enabler','coach','player'];

export default (member1,member2) => {
  return accountTypes.indexOf(member1.accountType) - accountTypes.indexOf(member2.accountType)
}
